package es.subastia.domain.usecase

import es.subastia.domain.model.AuctionDomainModel
import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.domain.repository.AuctionsRepository

class GetAuctionsUseCase(private val repository: AuctionsRepository) {
    suspend operator fun invoke(type: AuctionTypeDomainModel? = null, procedureType: es.subastia.domain.model.AuctionProcedureType? = null, province: ProvinceDomainModel? = null, searchQuery: String? = null): List<AuctionDomainModel> {
        return repository.getAuctions(type, procedureType, province, searchQuery)
    }
}
